import {RaisedButton} from "material-ui";

const React = require('react');

export default class RowProductPage extends React.Component {
    render() {
        return (
            <tr>
                <td>{this.props.name}</td>
                <td>{this.props.unit}</td>
                <td>{this.props.category}</td>
                <td>{this.props.price}</td>
                <td>{this.props.codeSsi || '-'}</td>
                <td style={{width: 202}}>
                    <div style={{display: 'flex', alignItems: 'center', gap: '10px', minWidth: '186px'}}>
                        <RaisedButton
                            primary
                            label={"Edit"}
                            onClick={() => this.props.onEditClicked(this.props.id, this.props.name,
                                this.props.unit, this.props.categoryId, this.props.price, this.props.codeSsi)}/>

                        <RaisedButton
                            secondary
                            label={"Delete"}
                            onClick={() => this.props.onDeleteClicked(this.props.index, this.props.id)}/>
                    </div>
                </td>
            </tr>
        )
    }
}
